import { styled } from 'linaria/lib/react';
import { COLORS } from 'styles/constants';

export const StyledCardWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledCardContent = styled.div<{ isSelectable: boolean }>`
  pointer-events: ${({ isSelectable }) => (isSelectable ? 'none' : 'auto')};
`;

export const StyledSelectionOverlay = styled.div<{ isSelected: boolean }>`
  position: absolute;
  inset: 0;
  z-index: 10;
  cursor: pointer;
  border-radius: 8px;
  pointer-events: auto;
`;

export const StyledCheckbox = styled.div<{ isSelected: boolean }>`
  position: absolute;
  bottom: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 1px solid ${COLORS.white[100]};
  background: ${({ isSelected }) => (isSelected ? COLORS.white[100] : 'transparent')};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 150ms ease;
`;

export const StyledSavedPicksWrap = styled.div`
  padding-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 56px;
  align-items: center;
  width: 100%;
  margin: 0 auto;
`;
